import { GROUP } from "@shared/config"
import { Role } from "@shared/contexts"

function changeDocumentTitle(
  role: Role,
  action: string,
  message?: string,
): void {
  if (!GROUP.STREAMER.includes(role)) return

  document.title = action + (message ? `|${message}` : "")
}

export default {
  changeStreamingUrl: (role: Role, message: string): void => {
    changeDocumentTitle(role, "change-streaming-url", message)
  },
  liveClosed: (role: Role): void => {
    changeDocumentTitle(role, "live-closed")
  },
  duplicateUser: (role: Role): void => {
    changeDocumentTitle(role, "duplicate-user")
  },
  firebaseDisconnected: (role: Role): void => {
    changeDocumentTitle(role, "firebase-disconnected")
  },
}
